import styled from 'styled-components';

// relative container uses inline-block to appropriately size the container

export const Relative = styled.div`
  display: inline-block;
  position: relative;
`;

